export const importedproductsmetrics = {
    'familiesCount': 10,
    'productItemsCount': 50,
    'productsCount': 100
 };